import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { withRouter } from "react-router-dom";
import { translate, MenuItemLink } from "react-admin";
import { AppContext } from "../../AppState";

import products from "../../modules/products";
import stocks from "../../modules/stocks";
import orders from "../../modules/orders";
import CustomerIcon from "../../modules/customers/CustomertIcon";
class Menu extends Component {
  state = {
    menuCatalog: false,
    menuSales: false,
    menuCustomers: false
  };

  static propTypes = {
    onMenuClick: PropTypes.func,
    logout: PropTypes.object
  };

  handleToggle = menu => {
    this.setState(state => ({ [menu]: !state[menu] }));
  };

  render() {
    const { onMenuClick, translate } = this.props;
    return (
      <div>
        {" "}
        {/* <DashboardMenuItem onClick={onMenuClick} /> */}
        <MenuItemLink
          to={`/`}
          primaryText={translate(`resources.customer.name`, {
            smart_count: 2
          })}
          leftIcon={<CustomerIcon />}
          onClick={onMenuClick}
        />
        <AppContext.Consumer>
          {({ selected }) =>
            selected.customerId && (
              <MenuItemLink
                to={`/orders`}
                primaryText={translate(`resources.orders.name`, {
                  smart_count: 2
                })}
                leftIcon={<orders.icon />}
                onClick={onMenuClick}
              />
            )
          }
        </AppContext.Consumer>
        <MenuItemLink
          to={`/products`}
          primaryText={translate(`resources.products.name`, {
            smart_count: 2
          })}
          leftIcon={<products.icon />}
          onClick={onMenuClick}
        />
        <MenuItemLink
          to={`/stock`}
          primaryText={translate(`resources.stock.name`, {
            smart_count: 2
          })}
          leftIcon={<stocks.icon />}
          onClick={onMenuClick}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  open: state.admin.ui.sidebarOpen,
  theme: state.theme,
  locale: state.i18n.locale
});

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    {}
  ),
  translate
);

export default enhance(Menu);
